var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.features),function(feature){return _c('a',{key:feature.name,staticClass:"mb-2 white--text text-foot d-block text-none",attrs:{"href":feature.link},domProps:{"innerHTML":_vm._s(feature.name)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }